import RulesTester from './RulesTester';
export default RulesTester;